import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTime',
  standalone: false
})
export class FormatTimePipe implements PipeTransform {

  transform(value: string): any {
    if (value !== undefined) {
      let divided = value.split(':');
      let num = parseFloat(divided[2]);
      let round = Math.ceil(num);
      const joinTime = `${ divided[0]}:${divided[1]}:${round}`;

      return joinTime;
    }

  }

}
